import axios from 'axios';
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import NavBar from '../components/NavBar';
import { URL_NEW_MAPA_API } from '../config/urls';
import './Contratos.css';

const API_HEADERS = {
  Accept: 'application/json',
  Authorization:
    'Bearer 3bca4df63f1cc72e4c8ad364a5d426f77e65f5084b40be712cf0bc4ed34ac61e',
};

const FILTROS = [
  { key: 'todos', label: 'Todos' },
  { key: 'pendente', label: 'Pendentes' },
  { key: 'assinado', label: 'Assinados' },
];

// Palavras que ficam minúsculas no meio de nomes ("Universidade de São Paulo")
const PALAVRAS_MINUSCULAS = ['a', 'e', 'o', 'da', 'de', 'do', 'das', 'dos', 'em', 'na', 'no'];

// Faculdade e curso vêm do banco em CAIXA ALTA
function titleCase(text) {
  if (!text) return '';
  return String(text)
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .map((word, i) =>
      i > 0 && PALAVRAS_MINUSCULAS.includes(word)
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(' ');
}

function normalizar(text) {
  return String(text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

function iniciais(nome) {
  const partes = String(nome || '?').trim().split(/\s+/);
  const primeira = partes[0] ? partes[0].charAt(0) : '?';
  const ultima = partes.length > 1 ? partes[partes.length - 1].charAt(0) : '';
  return (primeira + ultima).toUpperCase();
}

class Contratos extends React.Component {
  constructor(props) {
    super(props);
    document.title = 'Contratos';
    this.state = {
      usuarioLogado: '',
      search: '',
      contracts: [],
      expandedRows: {},
      statusFilter: 'todos',
      // Número do contrato quando a lista mostra o resultado de uma busca no servidor
      remoteResult: null,
      loading: true,
    };
  }

  async componentDidMount() {
    if (sessionStorage.getItem('usuarioLogado')) {
      const userInfo = JSON.parse(sessionStorage.getItem('usuarioLogado'))[0];

      this.setState({ usuarioLogado: userInfo });
      await this.fetchContracts(userInfo.idUsuario);
    }
  }

  canManage() {
    const u = this.state.usuarioLogado;
    return u.Funcao !== 'VENDEDOR' && u.Nivel !== 'RESTRITO';
  }

  splitDate(value) {
    if (!value) return null;
    const date = new Date(value);
    if (isNaN(date.getTime())) return null;

    return {
      date: date.toLocaleDateString('pt-BR'),
      time: date.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      }),
    };
  }

  formatContract(c) {
    const signers = c.signers || [];

    return {
      ...c,
      signers,
      turma: c.turma || null,
      signedCount: signers.filter((s) => s.status === 'signed').length,
      isSigned: c.status === 'signed',
    };
  }

  sortNewestFirst(contracts) {
    return contracts.slice().sort((a, b) => {
      const ta = a.sent_at ? new Date(a.sent_at).getTime() : 0;
      const tb = b.sent_at ? new Date(b.sent_at).getTime() : 0;
      return tb - ta;
    });
  }

  toggleRow(contractId) {
    this.setState((prevState) => ({
      expandedRows: {
        ...prevState.expandedRows,
        [contractId]: !prevState.expandedRows[contractId],
      },
    }));
  }

  async reload() {
    if (this.state.remoteResult) {
      await this.fetchContract(this.state.remoteResult);
    } else {
      await this.fetchContracts(this.state.usuarioLogado.idUsuario);
    }
  }

  async forceComplete(contractNumber) {
    if (!window.confirm(`Confirma a conclusão forçada do contrato ${contractNumber}?\n\nIsso vai finalizar o contrato e gerar o acesso no sistema da agência, mesmo sem todas as assinaturas.`)) {
      return;
    }

    try {
      await axios.post(
        `${URL_NEW_MAPA_API}/contracts/number/${contractNumber}/force-complete`,
        {},
        { headers: API_HEADERS }
      );

      toast.success('Contrato concluído com sucesso! O acesso será gerado em breve.');
      await this.reload();
    } catch (error) {
      const msg = (error.response && error.response.data && error.response.data.error) || 'Não foi possível concluir o contrato.';
      toast.error(msg);
    }
  }

  async cancelContract(contractNumber) {
    if (
      !window.confirm(
        `Confirma o CANCELAMENTO do contrato ${contractNumber}?\n\nO documento será apagado na ZapSign e os links de assinatura já enviados deixarão de funcionar.\n\nO contrato sairá desta lista e poderá ser gerado novamente.`
      )
    ) {
      return;
    }

    try {
      await axios.delete(
        `${URL_NEW_MAPA_API}/contracts/number/${contractNumber}`,
        { headers: API_HEADERS }
      );

      toast.success('Contrato cancelado com sucesso!');

      if (this.state.remoteResult) {
        this.clearSearch();
      } else {
        await this.fetchContracts(this.state.usuarioLogado.idUsuario);
      }
    } catch (error) {
      const msg =
        (error.response && error.response.data && error.response.data.error) ||
        'Não foi possível cancelar o contrato.';
      toast.error(msg);
    }
  }

  copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(
      () => {
        toast.success('Link copiado para a área de transferência!');
      },
      () => {
        toast.error('Erro ao copiar o link!');
      }
    );
  }

  // Enter busca no servidor só quando o número digitado não está na lista
  // carregada (ex.: contrato de outro vendedor).
  handleSearchKeyPress(e) {
    if (e.key !== 'Enter') return;

    const term = this.state.search.trim();
    const jaNaLista = this.state.contracts.some(
      (c) => String(c.contract_number) === term
    );
    if (/^\d{3,}$/.test(term) && !jaNaLista) {
      this.fetchContract(term);
    }
  }

  clearSearch() {
    const voltarParaLista = !!this.state.remoteResult;
    this.setState({ search: '', remoteResult: null }, () => {
      if (voltarParaLista && this.state.usuarioLogado.idUsuario) {
        this.fetchContracts(this.state.usuarioLogado.idUsuario);
      }
    });
  }

  async fetchContract(contractNumber) {
    this.setState({ loading: true });
    axios
      .get(URL_NEW_MAPA_API + `/contracts/number/${contractNumber}`, {
        headers: API_HEADERS,
      })
      .then((response) => {
        this.setState({
          contracts: [this.formatContract(response.data.contract)],
          remoteResult: contractNumber,
          search: '',
          statusFilter: 'todos',
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
        toast.info(
          error.response && error.response.status === 404
            ? `Contrato ${contractNumber} não encontrado.`
            : 'Não foi possível buscar o contrato. Tente novamente!'
        );
        this.setState({ loading: false });
      });
  }

  async fetchContracts(userId) {
    this.setState({ loading: true });
    axios
      .get(URL_NEW_MAPA_API + `/contracts/${userId}/signature-status`, {
        headers: API_HEADERS,
      })
      .then((response) => {
        const contracts = response.data.contracts.map((c) =>
          this.formatContract(c)
        );

        this.setState({
          contracts: this.sortNewestFirst(contracts),
          remoteResult: null,
          loading: false,
        });
      })
      .catch(() => {
        toast.error('Não foi possível buscar os contratos. Tente novamente!');
        this.setState({ loading: false });
      });
  }

  // Contratos que batem com a busca, antes do filtro de status
  getSearchedContracts() {
    const term = normalizar(this.state.search.trim());
    if (!term) return this.state.contracts;

    return this.state.contracts.filter((c) => {
      const t = c.turma || {};
      const alvo = normalizar(
        [
          c.contract_number,
          c.title,
          t.faculdade,
          t.sigla,
          t.curso,
          t.cidade,
          t.estado,
          t.ano_semestre,
        ].join(' ')
      );
      return alvo.indexOf(term) !== -1;
    });
  }

  filterByStatus(contracts, status) {
    if (status === 'pendente') return contracts.filter((c) => !c.isSigned);
    if (status === 'assinado') return contracts.filter((c) => c.isSigned);
    return contracts;
  }

  renderLoadingScreen() {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '400px',
          padding: '40px',
        }}
      >
        <style>
          {`
            @keyframes pulse {
              0%, 100% {
                transform: scale(1);
                opacity: 1;
              }
              50% {
                transform: scale(1.1);
                opacity: 0.8;
              }
            }
            @keyframes spin {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }
            @keyframes fadeIn {
              from {
                opacity: 0;
                transform: translateY(10px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
          `}
        </style>
        <div
          style={{
            width: '80px',
            height: '80px',
            border: '6px solid #e9ecef',
            borderTop: '6px solid #007bff',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            marginBottom: '30px',
          }}
        ></div>
        <h4
          style={{
            color: '#495057',
            marginBottom: '10px',
            animation: 'fadeIn 0.5s ease-in',
            fontWeight: '600',
          }}
        >
          Buscando contratos...
        </h4>
        <p
          style={{
            color: '#6c757d',
            fontSize: '14px',
            animation: 'fadeIn 0.7s ease-in',
            textAlign: 'center',
          }}
        >
          Estamos consultando os dados na ZapSign
        </p>
        <div
          style={{
            display: 'flex',
            gap: '8px',
            marginTop: '20px',
          }}
        >
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: '#007bff',
                borderRadius: '50%',
                animation: 'pulse 1.5s ease-in-out infinite',
                animationDelay: `${i * 0.2}s`,
              }}
            ></div>
          ))}
        </div>
      </div>
    );
  }

  renderDate(value) {
    const d = this.splitDate(value);
    if (!d) return <span className='ctr-muted'>—</span>;

    return (
      <div>
        <span className='ctr-main' style={{ fontWeight: 500 }}>
          {d.date}
        </span>
        <span className='ctr-sub'>{d.time}</span>
      </div>
    );
  }

  renderFaculdade(turma) {
    if (!turma || (!turma.sigla && !turma.faculdade)) {
      return <span className='ctr-muted'>—</span>;
    }

    const local = [turma.cidade, turma.estado].filter(Boolean).join('/');
    const nome = titleCase(turma.faculdade);

    return (
      <div title={[turma.faculdade, local].filter(Boolean).join(' · ')}>
        <span className='ctr-main'>{turma.sigla || nome}</span>
        <span className='ctr-sub'>
          {[turma.sigla ? nome : null, local].filter(Boolean).join(' · ')}
        </span>
      </div>
    );
  }

  renderFormatura(turma) {
    const anoSemestre = turma && turma.ano_semestre;
    const colacao = turma && turma.colacao;

    if (!anoSemestre && !colacao) {
      return <span className='ctr-muted'>—</span>;
    }

    const [ano, semestre] = anoSemestre ? anoSemestre.split('/') : [];

    return (
      <div>
        {anoSemestre ? (
          <span className='ctr-main'>
            {ano}
            <span style={{ fontWeight: 500, color: '#4b5563' }}>
              {' '}
              · {semestre}º sem.
            </span>
          </span>
        ) : (
          <span className='ctr-muted'>—</span>
        )}
        {colacao ? (
          <span className='ctr-sub'>
            Colação {colacao.mes.slice(0, 3).toLowerCase()}/{colacao.ano}
          </span>
        ) : null}
      </div>
    );
  }

  renderAssinaturas(c) {
    const total = c.signers.length;
    const pct = total ? Math.round((c.signedCount / total) * 100) : 0;

    return (
      <div className='ctr-sign'>
        <div className='ctr-sign-top'>
          <span className={`ctr-pill ${c.isSigned ? 'is-signed' : 'is-pending'}`}>
            {c.isSigned ? 'Assinado' : 'Pendente'}
          </span>
          <span className='ctr-sign-count'>
            {total ? `${c.signedCount}/${total}` : '—'}
          </span>
        </div>
        <div className={`ctr-progress ${c.isSigned ? 'is-done' : ''}`}>
          <span style={{ width: `${c.isSigned ? 100 : pct}%` }} />
        </div>
      </div>
    );
  }

  renderAcoes(c) {
    if (c.isSigned) return null;

    return (
      <div className='ctr-actions'>
        <button
          type='button'
          className='ctr-btn ctr-btn-danger'
          onClick={(e) => {
            e.stopPropagation();
            this.forceComplete(c.contract_number);
          }}
          title='Forçar conclusão do contrato mesmo sem todas as assinaturas'
        >
          <i className='fas fa-check-circle'></i> Forçar conclusão
        </button>
        <button
          type='button'
          className='ctr-btn ctr-btn-neutral'
          onClick={(e) => {
            e.stopPropagation();
            this.cancelContract(c.contract_number);
          }}
          title='Cancelar o contrato: apaga o documento na ZapSign e remove desta lista'
        >
          <i className='fas fa-ban'></i> Cancelar
        </button>
      </div>
    );
  }

  renderAssinantes(c, colSpan) {
    return (
      <tr>
        <td colSpan={colSpan} className='ctr-detail-cell'>
          <div className='ctr-detail'>
            <div className='ctr-detail-header'>
              <h6 className='ctr-detail-title'>
                Assinantes ({c.signedCount}/{c.signers.length})
              </h6>
              {c.view_url ? (
                <a
                  href={c.view_url}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='ctr-btn ctr-btn-primary'
                  style={{ textDecoration: 'none' }}
                >
                  <i className='fas fa-file-alt'></i> Ver documento
                </a>
              ) : null}
            </div>
            {c.signers.length === 0 ? (
              <span className='ctr-muted'>
                Nenhum assinante retornado pela ZapSign.
              </span>
            ) : (
              <div className='ctr-signers'>
                {c.signers.map((signer, idx) => {
                  const assinou = signer.status === 'signed';
                  const data = this.splitDate(signer.signed_at);

                  return (
                    <div
                      key={idx}
                      className={`ctr-signer ${assinou ? 'is-signed' : ''}`}
                    >
                      <div className='ctr-avatar'>{iniciais(signer.name)}</div>
                      <div className='ctr-signer-info'>
                        <div className='ctr-signer-name' title={signer.name}>
                          {signer.name}
                        </div>
                        <div className='ctr-signer-email' title={signer.email}>
                          {signer.email || '—'}
                        </div>
                      </div>
                      <div className='ctr-signer-side'>
                        <span
                          className={`ctr-pill ${
                            assinou ? 'is-signed' : 'is-pending'
                          }`}
                        >
                          {assinou ? 'Assinou' : 'Aguardando'}
                        </span>
                        {assinou ? (
                          <span className='ctr-signer-date'>
                            {data ? `${data.date} ${data.time}` : ''}
                          </span>
                        ) : signer.sign_url ? (
                          <button
                            type='button'
                            className='ctr-link-btn'
                            style={{ fontSize: 12 }}
                            onClick={() => this.copyToClipboard(signer.sign_url)}
                            title={signer.sign_url}
                          >
                            <i className='fas fa-link'></i> Copiar link
                          </button>
                        ) : null}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </td>
      </tr>
    );
  }

  renderVazio() {
    const term = this.state.search.trim();
    const podeBuscarNoServidor = /^\d{3,}$/.test(term);

    return (
      <div className='ctr-empty'>
        <i className='fas fa-folder-open'></i>
        <p>
          {term
            ? `Nenhum contrato encontrado para "${term}".`
            : 'Não há contratos para exibir.'}
        </p>
        {podeBuscarNoServidor ? (
          <button
            type='button'
            className='ctr-btn ctr-btn-primary'
            onClick={() => this.fetchContract(term)}
          >
            <i className='fas fa-search'></i> Buscar o contrato {term} em todos
            os contratos
          </button>
        ) : null}
      </div>
    );
  }

  renderTabela(contracts) {
    const canManage = this.canManage();
    const colSpan = canManage ? 8 : 7;

    if (contracts.length === 0) return this.renderVazio();

    return (
      <div className='ctr-table-wrap'>
        <table className='ctr-table'>
          <thead>
            <tr>
              <th>Contrato</th>
              <th>Faculdade</th>
              <th>Curso</th>
              <th>Formatura</th>
              <th>Assinaturas</th>
              <th>Criado em</th>
              <th>Concluído em</th>
              {canManage ? <th style={{ textAlign: 'right' }}>Ações</th> : null}
            </tr>
          </thead>
          <tbody>
            {contracts.map((c) => {
              const aberto = !!this.state.expandedRows[c.id];

              return (
                <React.Fragment key={c.id}>
                  <tr
                    className={`ctr-row ${aberto ? 'is-open' : ''}`}
                    onClick={() => this.toggleRow(c.id)}
                  >
                    <td>
                      <div className='ctr-number'>
                        <i className='fas fa-chevron-right ctr-chevron'></i>
                        {c.contract_number || c.title}
                      </div>
                    </td>
                    <td>{this.renderFaculdade(c.turma)}</td>
                    <td>
                      {c.turma && c.turma.curso ? (
                        titleCase(c.turma.curso)
                      ) : (
                        <span className='ctr-muted'>—</span>
                      )}
                    </td>
                    <td>{this.renderFormatura(c.turma)}</td>
                    <td>{this.renderAssinaturas(c)}</td>
                    <td>{this.renderDate(c.sent_at)}</td>
                    <td>{this.renderDate(c.signed_at)}</td>
                    {canManage ? <td>{this.renderAcoes(c)}</td> : null}
                  </tr>
                  {aberto ? this.renderAssinantes(c, colSpan) : null}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const pesquisados = this.getSearchedContracts();
    const visiveis = this.filterByStatus(pesquisados, this.state.statusFilter);
    const contagem = {
      todos: pesquisados.length,
      pendente: this.filterByStatus(pesquisados, 'pendente').length,
      assinado: this.filterByStatus(pesquisados, 'assinado').length,
    };

    return (
      <div className='ctr-page'>
        <ToastContainer
          position='bottom-left'
          autoClose={5000}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange={false}
          draggable={false}
        />
        <NavBar
          className='no-print'
          nome={this.state.usuarioLogado.Nome}
          funcao={this.state.usuarioLogado.Funcao}
        />
        <div className='container-fluid'>
          <div className='ctr-card'>
            <div className='ctr-header'>
              <div>
                <h5 className='ctr-title'>Contratos gerados</h5>
                <p className='ctr-subtitle'>
                  Acompanhe as assinaturas na ZapSign. Clique em um contrato
                  para ver os assinantes.
                </p>
              </div>
              <div className='ctr-header-actions'>
                <div className='ctr-search'>
                  <i className='fas fa-search'></i>
                  <input
                    type='text'
                    placeholder='Buscar por nº, faculdade, curso ou formatura...'
                    value={this.state.search}
                    onChange={(e) => this.setState({ search: e.target.value })}
                    onKeyPress={(e) => this.handleSearchKeyPress(e)}
                  />
                  {this.state.search ? (
                    <button
                      type='button'
                      className='ctr-search-clear'
                      onClick={() => this.clearSearch()}
                      title='Limpar busca'
                    >
                      <i className='fas fa-times'></i>
                    </button>
                  ) : null}
                </div>
                <button
                  type='button'
                  className='ctr-icon-btn'
                  onClick={() => this.reload()}
                  title='Atualizar lista'
                  disabled={this.state.loading}
                >
                  <i className='fas fa-sync-alt'></i>
                </button>
              </div>
            </div>

            {this.state.remoteResult ? (
              <div className='ctr-banner'>
                <span>
                  <i className='fas fa-info-circle'></i> Mostrando o contrato{' '}
                  <strong>{this.state.remoteResult}</strong>, encontrado na
                  busca geral.
                </span>
                <button
                  type='button'
                  className='ctr-link-btn'
                  onClick={() => this.clearSearch()}
                >
                  Voltar para a lista
                </button>
              </div>
            ) : null}

            {!this.state.loading && !this.state.remoteResult ? (
              <div className='ctr-filters'>
                {FILTROS.map((f) => (
                  <button
                    key={f.key}
                    type='button'
                    className={`ctr-filter ${
                      this.state.statusFilter === f.key ? 'is-active' : ''
                    }`}
                    onClick={() => this.setState({ statusFilter: f.key })}
                  >
                    {f.label}
                    <span className='ctr-filter-count'>{contagem[f.key]}</span>
                  </button>
                ))}
              </div>
            ) : null}

            {this.state.loading
              ? this.renderLoadingScreen()
              : this.renderTabela(visiveis)}
          </div>
        </div>
      </div>
    );
  }
}

export default Contratos;
